import { getQueryParams } from "src/standard/services/getQueryParams";
import { type HTTPQuery } from "src/standard/ts/queryParamUtils";
import { querystring } from "src/standard/ts/querystring";

export function addQueryParams<T extends unknown>(append: HTTPQuery<T>) {
  const queryParams = getQueryParams();

  // We want to get all the existing query params, and add the new ones
  const newQueryParams = { ...queryParams, ...append };

  // then push the state (so the URL updates)
  const queryString = querystring(newQueryParams);
  const hash = window.location.hash;
  const url = `${window.location.pathname}${queryString ? `?${queryString}` : ""}${hash}`;
  window.history.replaceState({}, "", url);
}
